import { httpClient } from "../../../shared/api/httpClient";
import { ProposalsResponse } from "../model/proposals.api";
import { ProposalDetailResponse } from "../model/proposalDetail.api";
import { normalizeApiError } from "../../../shared/errors/normalizeApiError";

const normalizeFailure = (error: unknown): never => {
    throw normalizeApiError(error);
};

export const proposalApi = {
    async getProposals(
        page: number,
        pageSize: number,
        search?: string,
        status?: string,
        createdFrom?: string,
        createdTo?: string,
        effectiveFrom?: string,
        effectiveTo?: string
    ): Promise<ProposalsResponse> {
        try {
            const params: Record<string, unknown> = {
                page,
                page_size: pageSize,
                search: search || undefined,
                status: status || undefined,
            };
            if (createdFrom) params.created_from = createdFrom;
            if (createdTo && (!createdFrom || createdTo > createdFrom)) params.created_to = createdTo;
            if (effectiveFrom) params.effective_from = effectiveFrom;
            if (effectiveTo && (!effectiveFrom || effectiveTo > effectiveFrom)) params.effective_to = effectiveTo;

            const response = await httpClient.get<ProposalsResponse>("/proposes", {
                params,
            });
            return response.data;
        } catch (error) {
            return normalizeFailure(error);
        }
    },
    async getProposalById(id: number): Promise<ProposalDetailResponse> {
        try {
            const response = await httpClient.get<ProposalDetailResponse>(`/proposes/${id}`);
            return response.data;
        } catch (error) {
            return normalizeFailure(error);
        }
    },
};
